var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-button',{attrs:{"icon":_vm.icon,"size":_vm.size,"title":_vm.title,"tabindex":_vm.tabindex},on:{"click":_vm.doLogout}})}
var staticRenderFns = []

export { render, staticRenderFns }